import React from 'react';
import c from '../w.js';

const IconEur = React.memo(
  c(
    /* @__PURE__ */ React.createElement("path", { d: "M15.4925 10.4538H10.6089C11.0692 8.7088 12.1814 7.86505 13.6132 7.86505C14.7318 7.86505 15.5947 8.38919 16.2084 8.87499L17.1033 6.97016C16.1572 6.17755 14.9811 5.7301 13.6132 5.7301C10.8966 5.7301 8.84474 7.46874 8.21832 10.4538H6.89517L6.3902 11.8153H8.03935C8.02656 12.0263 8.02017 12.2436 8.02017 12.4673C8.02017 12.6783 8.02656 12.8892 8.03935 13.0937H6.89517L6.3902 14.4744H8.21832C8.84474 17.4531 10.8966 19.179 13.6132 19.179C14.93 19.179 16.1509 18.7763 17.0649 17.9837L16.1572 16.0788C15.6011 16.5263 14.7382 17.044 13.6132 17.044C12.175 17.044 11.0692 16.2194 10.6089 14.4744H13.6516L14.3099 13.0937H10.398C10.3852 12.8956 10.3788 12.6846 10.3788 12.4673C10.3788 12.2436 10.3852 12.0263 10.398 11.8153H14.8724L15.4925 10.4538Z" })
  )
);

export { IconEur };
